export default __webpack_public_path__ + "assets/home_phone.fc1aea6e.webp";